import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    container: {
      borderTop: "1px solid #9c9c9c",
      borderBottom: "1px solid #9c9c9c",
      paddingBottom: "40px",
      "& .MuiTable-root": {
        "& .MuiTableRow-root": {
          "& .MuiTableCell-root": {
            "& .MuiTableSortLabel-root": {
              "&:hover": {
                color: "#bbdefb"
              }
            },
            "& .MuiTableSortLabel-active": {
              color: "#bbdefb",
              "& .MuiTableSortLabel-icon": {
                color: "#bbdefb"
              }
            }
          },
          "&:nth-child(even)": {
            backgroundColor: "rgba(5,89,141, 0.1)"
          }
        }
      }
    },
    topHeader: {
      borderBottom: "1px solid #9c9c9c",
      fontSize: "0.5 rem",
      padding: "10px 20px 10px 10px"
    },
    toolbar: {
      padding: "0px",
      "& .MuiButtonBase-root": {
        color: "#fff",
        bottom: "12px",
        zIndex: 100
      }
    }
  })
);
